<template>
  <user-profile :user-id="userId"></user-profile>
</template>
<script>
  import UserProfile from '@/pages/User/UserProfile';

  export default {
    components: {
      UserProfile
    },
    data() {
      return {
        userId: this.$route.params.userId
      }
    }
  }
</script>
<style></style>